import { render, staticRenderFns } from "./SpinnerAnimation.vue?vue&type=template&id=5c880118&scoped=true&"
import script from "./SpinnerAnimation.vue?vue&type=script&lang=js&"
export * from "./SpinnerAnimation.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerAnimation.vue?vue&type=style&index=0&id=5c880118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c880118",
  null
  
)

export default component.exports